import React from 'react';
import { useIntl } from 'react-intl';
import { Container, Label } from 'semantic-ui-react';
import HoverActionButtons from '@/components/buttons/HoverActionButtons';

const RequestLabelGroup = ({
  code,
  category,
  labels,
  canEdit,
  showEdit,
}) => {
  const intl = useIntl();
  if (!canEdit) {
    return (
      <Label.Group className="aridhia-request-label-group">
        {labels.map((value) => (
          <Label key={value.id} content={value.name} />
        ))}
      </Label.Group>
    );
  }

  if (labels.length > 0) {
    return (
      <HoverActionButtons message="click.to.add">
        <Label.Group
          as="a"
          className="aridhia-request-label-group"
          onClick={() => showEdit(category, code)}
        >
          {labels.map((value) => (
            <Label key={value.id} content={value.name} />
          ))}
        </Label.Group>
      </HoverActionButtons>
    );
  }

  return (
    <Container
      as="a"
      className="form-placeholder"
      content={intl.formatMessage({ id: 'click.to.edit' })}
      onClick={() => showEdit(category, code)}
    />
  );
};

export default RequestLabelGroup;
